import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <Player>
            <source src="https://wiki.instar.com/videos/Eine_Portweiterleitung_bei_einem_ASUS_Router_einrichten.mp4" />
        </Player>
        <EuiText>
            <p>Asus Router Portweiterleitung / Freigabe einrichten. Auf <OutboundLink href="https://www.youtube.com/watch?v=Y6aQGp6jxzY" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard